// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#calendar-container {
    height: 600px;
  }

  a{
    text-decoration: none;
  }
`, "",{"version":3,"sources":["webpack://./src/css/Calendarcss.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB","sourcesContent":["#calendar-container {\n    height: 600px;\n  }\n\n  a{\n    text-decoration: none;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
